export type ImagesPayload = {
  orderId: number;
  orderAttachmentId: number;
};

export type ImageDetails = {
  fileUrl: string;
};

export type ImageDetailsState = {
    data: ImageDetails;
    loading: boolean;
    error: string | null;
}

export const initialState: ImageDetailsState = {
    data: {
      fileUrl : "",
    },
    loading: false,
    error: null,
};

export type ImagesServiceOperators = {
  imageDetails: ImageDetails;
  fetchOrderHistoryImageInfo: (data: ImagesPayload) => void;
};

